import React from "react";
import PropTypes from "prop-types";
import { Divider, Typography, Grid } from "@mui/material";
import UpperCaseText from "../../../utils/UpperCaseText";
import fordStyles from "./DashboardCards-Ford.module.scss";
import { IS_FORD_BRAND } from "../../../utils/EmpUtil";
import lincolnStyles from "./DashboardCards-Lincoln.module.scss";
import Skeleton from "@mui/material/Skeleton";

let isFordBrand = true;
let styles = fordStyles;

export const Content = (props) => {
  const { showBreakDown, data, title, t } = props;
  isFordBrand = IS_FORD_BRAND(props.user.brand);
  styles = isFordBrand ? fordStyles : lincolnStyles;

  const generateTitle = (title) => {
    const uppercaseTitle = UpperCaseText(title);
    if (
      uppercaseTitle === "PURCHASE REQUESTS" ||
      uppercaseTitle === "PREORDERS"
    ) {
      return `${t("DealerDashboard.addedToday")}`;
    }
    return undefined;
  };

  return (
    <Grid
      container
      className={styles.contentGreen}
      justifyContent="center"
      alignItems="center"
      spacing={1}
    >
      <Grid item sm={6}>
        <div className={styles.cardNumber}>
          {data ? (
            <>
              <Typography
                variant="body1"
                sx={{ fontSize: 100, lineHeight: "100px", textAlign: "center" }}
              >
                {data?.totalAddedToday}
              </Typography>

              <Typography variant="body1" sx={{ textAlign: "center" }}>
                {generateTitle(title)}
              </Typography>
            </>
          ) : (
            <Skeleton height={120} />
          )}
        </div>
      </Grid>
      {showBreakDown && <BreakDown {...props} />}
    </Grid>
  );
};

const BreakDownItem = (props) => {
  const { count, singularName, pluralName, showDivider } = props;

  return (
    <>
      <Grid item xs={6} sm={4}>
        <Typography variant="body2" sx={{ color: "text.primary", p: 1 }}>
          {count} {count === 1 ? singularName : pluralName}
        </Typography>
      </Grid>

      {showDivider && <Divider />}
    </>
  );
};

const BreakDown = (props) => {
  const { data, t } = props;

  return (
    <Grid item xs>
      <Grid container direction="column" className={styles.breakdown}>
        <BreakDownItem
          count={data?.purchaseRequests}
          singularName={t("DealerDashboard.purchaseRequest")}
          pluralName={t("DealerDashboard.purchaseRequests")}
          showDivider={true}
        />

        <BreakDownItem
          count={data?.tradeIns}
          singularName={t("DealerDashboard.tradeIn")}
          pluralName={t("DealerDashboard.tradeIns")}
          showDivider={true}
        />

        <BreakDownItem
          count={data?.downPayments}
          singularName={t("DealerDashboard.downPayment")}
          pluralName={t("DealerDashboard.downPayments")}
          showDivider={false}
        />
      </Grid>
    </Grid>
  );
};

const dashboardDataPropType = PropTypes.shape({
  totalAddedToday: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  purchaseRequests: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  tradeIns: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  downPayments: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
});

Content.propTypes = {
  showBreakDown: PropTypes.bool,
  data: dashboardDataPropType,
  title: PropTypes.string.isRequired,
  user: PropTypes.shape({
    brand: PropTypes.string,
  }).isRequired,
  t: PropTypes.func.isRequired,
};

Content.defaultProps = {
  showBreakDown: false,
  data: undefined,
};

BreakDownItem.propTypes = {
  count: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  singularName: PropTypes.string.isRequired,
  pluralName: PropTypes.string.isRequired,
  showDivider: PropTypes.bool,
};

BreakDownItem.defaultProps = {
  count: undefined,
  showDivider: false,
};

BreakDown.propTypes = {
  data: dashboardDataPropType,
  t: PropTypes.func.isRequired,
};

BreakDown.defaultProps = {
  data: undefined,
};
